import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#424242', // Modern dark gray
      light: '#6d6d6d',
      dark: '#2c2c2c',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#757575', // Medium gray
      light: '#a4a4a4',
      dark: '#494949',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
        contained: {
          background: 'linear-gradient(135deg, #424242 0%, #2c2c2c 100%)',
          color: '#ffffff',
          // Ensure icons inherit white color as well
          '& .MuiButton-startIcon, & .MuiButton-endIcon': {
            color: '#ffffff',
          },
          '&:hover': {
            background: 'linear-gradient(135deg, #2c2c2c 0%, #212121 100%)',
            color: '#ffffff',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.06)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(135deg, #424242 0%, #2c2c2c 100%)',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
